import React, { useState } from "react";
import { Button } from "@letsbit/milkylb";
import { messages } from "./messages";
import { FormattedMessage } from "react-intl";
import { useDownloadDocumentMerk } from "hooks/merk/useDownloadDocumentMerk";
import { ACCOUNT_PROVIDERS } from "@letsbit/malcolmlb";

export const DownloadActivityEscoCoupon: React.FC<{ couponId: string }> = ({
  couponId,
}) => {
  const [loading, setLoading] = useState(false);
  const { downloadDocument } = useDownloadDocumentMerk();

  const generatePDF = async () => {
    try {
      setLoading(true);

      downloadDocument(couponId, ACCOUNT_PROVIDERS.ESCO);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      isLoading={loading}
      fill="clear"
      onClick={() => {
        generatePDF();
      }}
    >
      <FormattedMessage {...messages.downloadButton} />
    </Button>
  );
};
